import { HttpClient } from '@angular/common/http';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PerformanceInvestmentService = /** @class */ (function () {
    function PerformanceInvestmentService(http) {
        this.http = http;
        this._performanceInvestUrl = oneAssetApi + "/Performance/Investment";
    }
    PerformanceInvestmentService.prototype.getPerformanceInvest = function (fundId, date) {
        var _body = { fundId: fundId, date: date };
        return this.http.post(this._performanceInvestUrl, _body);
    };
    PerformanceInvestmentService.ngInjectableDef = i0.defineInjectable({ factory: function PerformanceInvestmentService_Factory() { return new PerformanceInvestmentService(i0.inject(i1.HttpClient)); }, token: PerformanceInvestmentService, providedIn: "root" });
    return PerformanceInvestmentService;
}());
export { PerformanceInvestmentService };
